import * as React from "react";

import clsx from "clsx";
import { useRouter } from "next/router";
import Image from "next/image";
import Cookies from "universal-cookie";
import {
  Chip,
  CircularProgress,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import Tabs from "@material-ui/core/Tabs";
import Box from "@material-ui/core/Box";
import Tab from "@material-ui/core/Tab";

import { useWindowSize } from "../../../../helpers/hooks";
import RoundButton from "../../../common/button/RoundButton";
import SolidSelectBox from "../../../common/selectBox/SolidSelectBox";
import SelectSupportValue from "./selectSupportValue";
import NoGatewayDialog from "./NoGatewayDialog";
import SimpleTextField from "../../../common/textfield/SimpleTextField";
import { getApiService, GetWaysToPay } from "../../../../services/AgapeAPI";
import euro from "../../../../public/assets/icons/euro.svg";
import crypto from "../../../../public/assets/icons/crypto.svg";
import cash from "../../../../public/assets/icons/cash.svg";
import CurrencyPayment from "./CurrencyPayment";
import CryptoPanel from "./CryptoPanel";
import CurrencyFormat from "../../../../services/CurrencyFormat";
import {
  newConvertPersianDigitsToEnglish,
  newPersianDigitsMapper,
} from "../../../../helpers/validators";
import WalletUseingComponent from "../../../common/walletUseingComponent/WalletUseingComponent";

const numbers = /^(|[0-9]\d*)$/;

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  "@keyframes showContent": {
    "0%": {
      opacity: 0,
    },
    "100%": {
      opacity: 1,
    },
  },
  root: {
    "& .MuiInputBase-root": {
      width: "100%",
    },
    "& .MuiTab-wrapper": {
      margin: "5px",
    },
    "& .MuiTabs-indicator": {
      backgroundColor: "#f7f7f7",
    },
    "& .Mui-selected": {
      "& .MuiTab-wrapper": {
        borderRadius: "7px",
        boxShadow: "0 1px 5px 0 rgba(10, 5, 74, 0.3)",
        backgroundColor: "white",
        padding: "10px",
        // zoom: "120%",
      },
    },
    width: "96%",
    margin: "20px 10px",
    borderRadius: "20px",
    position: "relative",
  },
  paymentField: {
    fontWeight: "500",
    marginTop: "39px",
  },
  t1Padding: {
    paddingTop: "30px",
  },
  paytitle: {
    fontSize: "2.909rem !important",
    borderRadius: "5px",
    display: "flex",
    justifyContent: "center",
    fontWeight: "bold",
    fontFamily: "Vazir-Bold",
    alignItems: "center",
    lineHeight: "4rem",
    height: "8.1rem",
    overflow: "hidden",
    color: "white",
    backgroundColor: "#546c64",
    [theme.breakpoints.only("md")]: {
      fontSize: "1.909rem !important",
    },
  },
  box: {
    backgroundColor: "rgba(0, 150, 147, 0.03)",
    border: "1px solid teal",
    borderRadius: "10px",
    padding: "20px 0",
    width: "100%",
    marginTop: "50px",
    fontFamily: "Vazir",
    [theme.breakpoints.down("sm")]: {
      backgroundColor: "#fff",
    },
  },
  t5: {
    fontSize: "18px",
    color: "rgba(21, 52, 42, 0.72)",
    padding: "10px 15px",
    fontWeight: "500",
    fontFamily: "Vazir",
  },
  payContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    marginTop: "40px",
  },
  payBtn: {
    borderRadius: "10px",
    margin: "5px",
  },
  tabPanel: { marginTop: "40px" },
  supportValueContainer: { marginTop: "30px", marginBottom: 15 },
}));

const cookies = new Cookies();

const IntroSection = ({ data, setPaymentData, info, opPay, ...props }) => {
  const size = useWindowSize();
  const router = useRouter();
  const isLogin = cookies.get("isLoggedIn") === "1";
  const [user, setUser] = React.useState();

  React.useEffect(() => {
    if (!user) {
      getApiService("ums/me").then((res) => setUser(res.data));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  // const [Amount, setAmount] = React.useState();
  const [isActive, setIsActive] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const [paymentValue, setPaymentValue] = React.useState(50000);

  const [intent, setIntent] = React.useState(0);
  const [localFavorite, setLocalFavorite] = React.useState(
    data.is_favorited ? 1 : 0
  );
  const [hasRequestedOwner] = React.useState(
    JSON.parse(
      typeof window !== "undefined" &&
        localStorage.getItem(`reqOwner__${data.id}`)
    ) || false
  );

  const localFavorites = JSON.parse(
    typeof window !== "undefined" && localStorage.getItem("favorites")
  );
  const [openNoPaymentGateway, setOpenNoPaymentGateway] = React.useState(false);

  const params = router.query;

  const localData =
    typeof window !== "undefined" &&
    JSON.parse(localStorage.getItem("payment_methods_data"));

  React.useEffect(() => {
    if (localData && localData.paymentValue) {
      setPaymentValue(localData.paymentValue);
      setIntent(localData.intent);
      localStorage.removeItem("payment_methods_data");
    }
  }, []);

  React.useEffect(() => {
    if (!localFavorites) {
      localStorage.setItem("favorites", JSON.stringify([]));
    } else if (localFavorites.indexOf(data.id) > -1) {
      setLocalFavorite(1);
    }
  }, [localFavorites, localFavorite, data.id]);

  const classes = useStyles({ size, hasRequestedOwner });

  const handleTabChanged = (value) => {
    setPaymentValue(value);
  };

  const handlePaymentChange = (event) => {
    // const payValue = event.target.value.replaceAll(/\D/g, "");
    // setActiveTab(DEFAULT_VALUES.indexOf(parseInt(payValue, 10)));
    setPaymentValue(event);
  };

  const handleDonation = () => {
    const paymentData = {
      amount: paymentValue * 10,
      ...(intent !== null && intent > 0
        ? { intent_id: intent.toString() }
        : null),

      organization_id: params.id,
    };

    if (isLogin || !data.require_login) {
      localStorage.removeItem("payment_methods_data");
      if (data?.has_online_payment === 1 || data?.has_wallet === 1) {
        setLoading(true);

        opPay(paymentData);
      } else {
        setOpenNoPaymentGateway(true);
      }
    } else {
      localStorage.setItem(
        "failed_payment_for_auth",
        JSON.stringify({ url: "pay/dedicate-payments", data: paymentData })
      );

      localStorage.setItem(
        "payment_methods_data",
        JSON.stringify({ paymentValue, intent })
      );
      router.replace(`/login?from=${router.asPath}`);
    }
  };

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setIsActive(!isActive);
    setValue(newValue);
  };

  React.useEffect(() => {
    if (
      intent === 0 &&
      data &&
      data.is_visible_intents &&
      data.is_visible_intents[0]
    ) {
      setIntent(data.is_visible_intents[0].id);
    }
  }, [data]);

  return (
    <div className={classes.root}>
      <NoGatewayDialog
        open={openNoPaymentGateway}
        setOpen={setOpenNoPaymentGateway}
        title="آگاپه ای عزیز ضمن تشکر از نیت نیکوکارانه شما"
        subtitle={`شماره حساب ${data?.name}، هنوز به درگاه پرداخت متصل نشده است. لطفا جهت حمایت از این موسسه، با شماره تلفن آگاپه تماس حاصل فرمایید.`}
      />
      <Grid
        item
        md={12}
        className={clsx(
          classes.padding,
          classes.t1Padding,
          classes.paycontainer
        )}
      >
        <Typography className={classes.paytitle}>انتخاب روش پرداخت </Typography>

        <Box sx={{ width: "100%" }}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              indicatorColor="primary"
              value={value}
              onChange={handleChange}
              centered
              aria-label="icon position tabs example"
            >
              <Tab
                icon={<Image src={cash} alt="cash" width={30} height={30} />}
                label="پرداخت ریالی"
                {...a11yProps(0)}
                disabled={
                  data.has_online_payment === 0 && data?.has_wallet === 0
                }
              ></Tab>
              <Tab
                icon={<Image src={euro} alt="euro" width={30} height={30} />}
                label="پرداخت ارزی"
                {...a11yProps(1)}
                disabled={data.has_currency_payment === 0}
              />

              <Tab
                icon={
                  <Image src={crypto} alt="crypto" width={30} height={30} />
                }
                label="پرداخت رمزارز"
                {...a11yProps(2)}
                disabled={data.has_crypto_payment === 0}
              />
            </Tabs>
          </Box>
          <TabPanel className={classes.tabPanel} value={value} index={0}>
            {data?.has_online_payment || data?.has_wallet ? (
              <div>
                <Grid item md={6} className={classes.padding}>
                  <SolidSelectBox
                    extraHandler={setIntent}
                    defaultValue={intent}
                    value={intent}
                    height="40px !important"
                    items={[
                      { id: 0, name: " انتخاب نیت" },
                      ...data?.is_visible_intents,
                    ]}
                  />
                </Grid>{" "}
                <Grid item md={7} className={classes.padding}>
                  <SimpleTextField
                    type="text"
                    value={CurrencyFormat(paymentValue)}
                    onChange={(e) => {
                      const text = e.target.value.replaceAll(",", "");
                      const en = newConvertPersianDigitsToEnglish(text);
                      if (numbers.test(en)) {
                        handlePaymentChange(en);
                      }
                    }}
                    EndAdornment={<Chip label="تومان" />}
                    inputProps={{
                      maxLength: 15,
                    }}
                    customClassName={classes.paymentField}
                  />
                </Grid>
                <Grid item md={12} className={classes.supportValueContainer}>
                  <SelectSupportValue
                    setAmount={setPaymentValue}
                    amount={paymentValue}
                    handleTabChanged={handleTabChanged}
                  />
                </Grid>
                {/* <RoundButton
                      customClassName={classes.payBtn}
                      fullWidth
                      onClick={handleDonation}
                    >
                      {loading ? (
                        <CircularProgress color="white" size={25} />
                      ) : (
                        "پرداخت"
                      )}
                    </RoundButton> */}
                <WalletUseingComponent
                  paymentData={{
                    amount: paymentValue * 10,
                    ...(intent !== null && intent > 0
                      ? { intent_id: intent.toString() }
                      : null),

                    organization_id: params.id,
                  }}
                  paymentURL="pay/dedicate-payments"
                  amount={paymentValue}
                  wallet={user?.wallet?.balance || 0}
                  callback={() =>
                    router.replace(`/login?from=${router.asPath}`)
                  }
                />
              </div>
            ) : null}{" "}
          </TabPanel>
          <TabPanel value={value} index={1} dir="ltr">
            <CurrencyPayment data={data} />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <Grid item md={12}>
              <div className={classes.box}>
                <Typography variant="h4" className={classes.t5}>
                  حامی گرامی!
                  <br />
                  برای حمایت از طریق رمز ارز:
                  <ul className={classes.ul}>
                    <li> ابتدا آدرس wallet را کپی کنید.</li>
                    <li>پرداخت خود را از انجام دهید.</li>
                    <li>در پایان فرم زیر را با اطلاعات رسید خود تکمیل کنید.</li>
                  </ul>
                </Typography>
              </div>
            </Grid>
            <CryptoPanel info={info} data={data} />
          </TabPanel>
        </Box>
      </Grid>
    </div>
  );
};

export default IntroSection;
